import { ContentStateInterface, InsertionIdentification } from '../../../../@types/types'
import { RealEstateDTO } from '../../../../@types/real-estate-api-types'
import { estateToApi } from './estate/estateToApi'
import { attachmentsToApi } from './attachments/attachmentsToApi'
import { multimediaOperationsToApi } from './multimediaOperations/multimediaOperationsToApi'
import { AddressFeatureState, FlowState, MultimediaState } from '../../../../@types/state-types'
import { getFeatureSwitchRuntimeValue } from '../../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../../utils/features/featureSwitches'

export const realEstateToApi = (
  ident: InsertionIdentification,
  insertionData: ContentStateInterface,
  multimediaFeature: MultimediaState,
  flowFeature: FlowState,
  addressFeature: AddressFeatureState
): RealEstateDTO => {
  const isDepositGuaranteeEnabled =
    getFeatureSwitchRuntimeValue(FeatureSwitch.PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE) === true &&
    flowFeature.flowInformation.options?.depositGuaranteeEnabled === true

  return {
    attachments: attachmentsToApi(multimediaFeature.attachments),
    estate: estateToApi(ident, insertionData, addressFeature, flowFeature.flowInformation),
    isDepositGuaranteeAllowed: isDepositGuaranteeEnabled ? (insertionData.isDepositGuaranteeAllowed ?? false) : null,
    multimediaOperations: multimediaOperationsToApi(multimediaFeature),
  }
}
